// 살까말까 결정방 활성 목록 훅 (시그니처 6엔진 Step 5 진입점 공용)
// 금융 NavCard가 사용. 토글 OFF면 서버가 [] 반환 → 진입점 숨김(design doc §6·§7).
// GET /api/mobile/buy-or-not?kind= (kind 생략=전체) → list_active_polls RPC. 실패 시 조용히 [].
import { useState, useEffect } from 'react';
import { apiFetch } from './api';

export interface PollLite {
  id: string;
  kind: 'stock' | 'consumer';
  action: 'buy' | 'sell';
  title: string;
  symbol: string | null;
  price: number | null;
  is_example: boolean;
  status: 'open' | 'closed';
  created_at: string;
  ai_verdict: string | null;
  dist: { for: number; against: number };
  my_side: 'for' | 'against' | null;
}

export function useActiveBuyOrNotPolls(): PollLite[] {
  const [polls, setPolls] = useState<PollLite[]>([]);
  useEffect(() => {
    let alive = true;
    apiFetch<{ ok: boolean; result: PollLite[] }>('/api/mobile/buy-or-not')
      .then((res) => { if (alive) setPolls(Array.isArray(res?.result) ? res.result : []); })
      .catch(() => { /* 진입점은 best-effort — 실패 시 미노출 */ });
    return () => { alive = false; };
  }, []);
  return polls;
}
